<template>
  <v-col
    class="pa-0 pt-1"
    v-if="
      !productIngredientGroup.show_when_ingredient_selected ||
      (selectedIngredient &&
        productIngredientGroup.show_when_ingredient_selected === selectedIngredient.id)
    "
  >
    <v-row
      no-gutters
      class="px-3 px-md-4"
      align="center"
    >
      <div class="text-body-1 font-weight-bold text-md-subtitle-1 mr-2">
        {{ ingredientGroup.name || ingredientGroup.vendor_name }}
      </div>
    </v-row>
    <v-row
      dense
      class="px-3 py-2"
    >
      <one-ingredient-tile
        v-for="(productIngredient, index) in productIngredients"
        :key="index"
        :with-image="withImage"
        :product-ingredient="productIngredient"
        :product-ingredient-group="productIngredientGroup"
        :selected-ingredient="selectedIngredient"
        :disabled="disabled"
        @select="onIngredientSelect"
      />
    </v-row>
  </v-col>
</template>

<script>
  import OneIngredientTile from './OneIngredientTile'

  export default {
    name: 'OneIngredientGroup',

    components: {
      OneIngredientTile
    },

    props: {
      productIngredientGroup: Object,
      selectedIngredient: Object,
      selectedIngredients: Array,
      isProductSelected: Boolean,
      disabled: Boolean
    },

    computed: {
      ingredientGroup() {
        return this.productIngredientGroup.ingredient_group
      },

      productIngredients() {
        console.log(JSON.stringify(this.productIngredientGroup.ingredients))
        const selected = new Set(this.selectedIngredients)
        return this.productIngredientGroup.ingredients.filter(e => !selected.has(e.ingredient.id))
      },

      withImage() {
        for (let productIngredient of this.productIngredients) {
          if (productIngredient.ingredient.image) return true
        }
        return false
      }
    },

    methods: {
      onIngredientSelect(ingredient) {
        this.$emit('input', ingredient)
      }
    }
  }
</script>
